import { Injectable } from '@angular/core';
import { BaseService } from '../base-service';
import { DataApiService } from '../data-api/data-api.service';
import { FormatValidationService } from '../format-validation/format-validation.service';
import { BillOfLading } from './model/bill-of-lading';
import { BolSearchRequest } from '../../model/bol-search';

import { Envelope } from '@xpo-ltl/api-common';
import { ConfigManagerService } from '@xpo-ltl/config-manager';
import { ConfigManagerProperties } from '../../../core/model/config-manager-properties.enum';
import { HttpHeaders } from '@angular/common/http';

@Injectable()
export class BolApiService extends BaseService {

  constructor(
      private dataApiService: DataApiService,
      private configManager: ConfigManagerService,
      private formatValidator: FormatValidationService) {
    super();
  }

  /**
   * https://tctsr-api.ltl.xpo.com/billoflading/1.0/billsoflading
   */
  getBillOfLading(value: string): Promise<BillOfLading> {

    if ( value === null ) {
      throw new Error('Bol Instance Id or ProNumber is Required');
    }

    const id = value.trim();
    let bolUrl = this.getEndPoint();

    if (this.formatValidator.isValidProNumber(id)) {
      bolUrl += `?proNbr=${id}`;
    } else {
      bolUrl += `?bolInstId=${id}`;
    }

    return new Promise((resolve, reject) => {
      this.dataApiService.get(bolUrl, null, this._dataOptions).then(
          (response: Envelope) => {
            let res:any = response['data'];
            // Commodity package replacing for this LCS-17736 requirement 
            // Pallet2Way transforming to Pallet 
            if(res.bolCommodityDetails.length){
              res.bolCommodityDetails.forEach(element => {
                  if(element.pakageTxt === "Pallet2Way"){
                    element.pakageTxt = "Pallet"
                  }
              });
            }
            resolve(response['data'] as BillOfLading);
          },
          error => {
            reject(error);
          }
        );
    });
  }

  /**
   * Search BOLs using the new billofladingv2/2.0/orderentry-bol/searches API
   */
  searchBols(searchRequest: BolSearchRequest, showOverlay?: boolean, showErrorToast?: boolean): Promise<any[]> {
    this._dataOptions.loadingOverlayEnabled = (showOverlay === undefined) ? true : showOverlay;
    this._dataOptions.toastOnError = (showErrorToast === undefined) ? true : showErrorToast;

    const headers = new HttpHeaders().set('Content-Type', 'application/json');
    const url = this.configManager.getSetting(ConfigManagerProperties.bolApiEndpointV2) + '/searches';
    
    return new Promise((resolve, reject) => {
      this.dataApiService.post(url, JSON.stringify(searchRequest.toJSON()), null, this._dataOptions, { headers })
        .then(
          (response: Envelope) => resolve(response['data']['result'] || []),
          error => reject(error)
        );
    });
  }

  protected getEndPoint(): string {
    return this.configManager.getSetting(ConfigManagerProperties.bolApiEndpoint);
  }
}
